module.exports = __webpack_public_path__ + "assets/img/page-title-954179de.png";